module.exports = __webpack_public_path__ + "img/hospital-bed.07c87731.png";